import { Component } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AdministracionService } from 'src/app/administracion/administracion.service';

import { FAZILService, User, UserService } from 'src/app/core';
import { PlanOrganizacion } from 'src/app/modelo/PlanOrganizacion';

import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-info',
    templateUrl: './app.info.component.html',
})
export class AppInfoComponent {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    currentUser: User;
    plan: PlanOrganizacion;
    
    
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    visibleDialog: boolean = false;
    images:string[] = ['portada'];
    
    responsiveOptions:any[] = [
    {
        breakpoint: '768px',
        numVisible: 3
    },
    {
        breakpoint: '560px',
        numVisible: 2
    }];
    
    constructor(
        private userService: UserService,
        private fazilService: FAZILService,
        private config: PrimeNGConfig,
        private administracionService: AdministracionService,
        ){
            this.cargarDataConstructor();
        }
        
        cargarDataConstructor() {
        this.cargandoDataInit = true;
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }
    
    async cargarDataInit() {
        this.plan = this.currentUser.organization.planOrganizacion;
        console.log(this.currentUser);
    }
    
    recargarPlan($event) {
        this.fazilService.irALanding();
    }
    
}